module.exports = require("@pb/kit-util-page-dimensions");